import type { RevokeObjectURLType } from "@pdfking/compatibility"

export const RevokeObjectURL: RevokeObjectURLType = async url => URL.revokeObjectURL(url)
